const TO_DAYS_DIVISOR = 86400000;
const TO_HOURS_DIVISOR = 3600000;
const TO_MINUTES_DIVISOR = 60000;
const TO_SECONDS_DIVISOR = 1000;
export const calculateTimerValues = (intervalMs) => {
    const days = Math.floor(intervalMs / TO_DAYS_DIVISOR);
    const hours = Math.floor((intervalMs % TO_DAYS_DIVISOR) / TO_HOURS_DIVISOR);
    const minutes = Math.floor((intervalMs % TO_HOURS_DIVISOR) / TO_MINUTES_DIVISOR);
    const seconds = Math.floor((intervalMs % TO_MINUTES_DIVISOR) / TO_SECONDS_DIVISOR);
    return [days, hours, minutes, seconds];
};
